import { render } from "./CashAndBankBook.vue?vue&type=template&id=5dcd1a8a&scoped=true"
import script from "./CashAndBankBook.vue?vue&type=script&lang=js"
export * from "./CashAndBankBook.vue?vue&type=script&lang=js"

import "./CashAndBankBook.vue?vue&type=style&index=0&id=5dcd1a8a&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcd1a8a"]])

export default __exports__